import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromLocale from './locale.reducer';

export const selectState = createFeatureSelector<fromLocale.State>(
  fromLocale.localeFeatureKey
);

export const getLocales = createSelector(selectState, (state) => state.locales);

export const getDefaultLocale = createSelector(
  selectState,
  (state) => state.defaultLocale
);

export const getLocaleLabels = createSelector(selectState, (state) => {
  if (state.processLoading === 0 || (state.locales && state.defaultLocale))
    return state.locales[state.defaultLocale];
  return null;
});

export const getBiaImpactFn = createSelector(
  selectState,
  (state) => state.appKeyValues?.FN_BIA_IMPACT_MAO_DISPLAY
);

export const getLoadingStatus = createSelector(
  selectState,
  (state) => state.processLoading
);

export const getMenu = createSelector(
  selectState,
  (state) => state.appKeyValues?.APP_MENU
);

export const getLogo = createSelector(
  selectState,
  (state) => state.appKeyValues?.COMPANY_LOGO
);

export const getSettings = createSelector(
  selectState,
  (state) => state.appKeyValues
);
